import {
  formatCurrency,
  formatPoints,
  formatTax,
} from "../components/best-fares/format-price";
import type { SelectedToolbarPrice } from "./toolbar-price";

type BestFaresToolbarProperties = {
  message?: string;
  selectedPrice?: SelectedToolbarPrice;
};

const FOOTER_TRIP_LABELS: Record<SelectedToolbarPrice["tripType"], string> = {
  "one-way": "one-way/person",
  "round-trip": "roundtrip/person",
};

const getTripLabel = (tripType: SelectedToolbarPrice["tripType"]) =>
  FOOTER_TRIP_LABELS[tripType];

export const BestFaresToolbar = ({
  message,
  selectedPrice,
}: BestFaresToolbarProperties) => {
  if (!message && !selectedPrice) {
    return null;
  }

  let selectedPriceSlot = null;

  if (selectedPrice) {
    const { amount, currencyCode, tax, tripType, usePoints } = selectedPrice;

    selectedPriceSlot = (
      <div className="min-w-0 pe-3 text-end leading-tight">
        <div className="text-label font-extrabold text-foreground-primary-variant">
          {usePoints ? (
            <>
              <span>{formatPoints(amount)} pts</span>
              {tax ? <span> + {formatTax(tax, currencyCode)}</span> : null}
            </>
          ) : (
            formatCurrency(amount, currencyCode)
          )}
        </div>
        <div className="text-label text-foreground-on-surface">
          {getTripLabel(tripType)}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="
          grid min-w-0 flex-1 grid-cols-[minmax(0,2fr)_minmax(0,1fr)]
          items-center
        "
      >
        {message ? (
          <div
            className={
              selectedPrice
                ? `
                  hidden min-w-0 justify-self-start pe-3 text-start text-caption
                  text-foreground-on-surface

                  md:block
                `
                : `
                  min-w-0 justify-self-start pe-3 text-start text-caption
                  text-foreground-on-surface
                `
            }
          >
            {message}
          </div>
        ) : (
          <div />
        )}

        {selectedPriceSlot}
      </div>
    </>
  );
};
